import React from "react";

import SearchResults from "../components/others/SearchResults";
import Header from "../components/global/Header";
import Footer from "../components/global/Footer";

const Register = () => {
  return (
    <div>
      <Header />
      <SearchResults />
      <Footer />
    </div>
  );
};

export default Register;
